import React, { memo } from "react"
import { Container, Heading } from "@chakra-ui/react"
import { SectionProps, withSection } from "@app/hoc/Section"

import BookingWidget from "./BookingWidget"

export type BookingFormProps = GatsbyTypes.SanitySectionBookingForm & SectionProps

const BookingForm = ({ title }: BookingFormProps) => {
  return (
    <Container as="section" maxW="11xl" px={[4, 8]} py={[8, 16]} textAlign="center">
      <Heading as="h2" size="xl" pb="50px">
        {title}
      </Heading>
      <BookingWidget />
    </Container>
  )
}

export default memo(withSection(BookingForm))
